import React from 'react'
import PmPerformancePoints from '../PM TEMPLATE/PM PERFORMANCE POINT/PmPerformancePoints'
import PmOverallJobPerformance from '../PM TEMPLATE/PM OVERALL JOB PERFORMANCE/PmOverallJobPerformance'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { TabPanel, TabView } from 'primereact/tabview'


function DASHBOARD() {
    return (
        <>

            <div className="card" >
                {/* <Accordion multiple activeIndex={[0, 1]}> */}
                <Accordion multiple activeIndex={[0]}>
                    <AccordionTab header="PERFORMANCE HUDDLE" className='mt-2 '>
                        <PmPerformancePoints />
                    </AccordionTab>

                    <AccordionTab header="OVERALL JOB PERFORMANCE" className='mt-2 '>
                        <PmOverallJobPerformance />
                    </AccordionTab>
                </Accordion>

            </div>
        </>
    )
}

export default DASHBOARD